import { useEffect, useRef } from 'react';

const useInterval = (callback: () => void, delay: number) => {
  const savedCallback = useRef<any>({});

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current.callback = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    savedCallback.current.id = window.setInterval(() => {
      savedCallback.current?.callback();
    }, delay);
    return () => window.clearInterval(savedCallback.current.id);
  }, [delay]);

  return () => {
    window.clearInterval(savedCallback.current.id);
  };
};
export default useInterval;
